import './Progetto.css';
import ProgettoNav from './ProgettoNav';

function Progetto4() {
    return (
        <div className='progetto-container'>
            <ProgettoNav prevPath='/progetto-locali-storici' nextPath='/progetto-spasso-fvg' />
            <h1 className='progetto-title'>RELAZIONE PROGETTO</h1>
            <h2 className='progetto-subtitle'>"Le biblioteche pordenonesi: una (altra) storia da raccontare”</h2>

            <h3>AMBITO PRIORITARIO</h3>
            <p>
                Il progetto "Le biblioteche pordenonesi: una (altra) storia da raccontare" ricade ed è stato
                sviluppato nell'ambio delle finalità statutarie dell'Associazione Settemotivi.
            </p>
            <p>
                Il progetto, sviluppato tra il mese di gennaio e maggio 2025, aveva come obiettivo di far conoscere
                attraverso il programma radiofonico, delle attività "passate – presenti – future" della biblioteca
                del proprio Paese.
            </p>
            <p>
                Dalla numerosità degli ascolti e dall'entusiasmo con cui le Amministrazioni Comunali coinvolte, dal
                Sindaco, all'assessore alla cultura alle bibliotecarie, possiamo affermare che l'obiettivo è stato
                pienamente raggiunto. Oltre alla disponibilità è emerso l'amore e la dedizione che tutti gli
                operatori dedicano al loro lavoro che sembra quasi una missione, sempre pronti a cogliere le
                tendenze e le esigenze del momento per tutte le fasce d'età.
            </p>
            <p>
                Si è evidenziando soprattutto che nelle stesse non si trovano solo "libri", ma anche personale
                preparato e cordiale che sa anche guidare nella scelta, secondo le proprie indicazioni /
                preferenze, della/e letture o indirizzando verso il materiale per le ricerche su argomenti vari,
                in un ambiente sereno e protetto.
            </p>
            <p>Sono state evidenziate, dove presenti, le diverse iniziative ed eventi che vengono organizzati.</p>
            <p>
                Tutto questo al fine di incuriosire ed invogliare gli ascoltatori di tutte le età, dagli adulti ai
                bambini e perché no anche alle scuole e a quelli che non dedicano molto tempo alla lettura, per
                far si che abbiano il desiderio di avvicinarsi a questo mondo, ad investire un pòdel proprio
                tempo perché la lettura è conoscenza e la conoscenza è cultura.
            </p>

            <p>Per ogni puntata è stato seguito un filo logico, compatibilmente con le notizie conosciute quali:</p>
            <ul className='progetto-indent'>
                <li>Se intitolata a personaggi che hanno dato lustro alla stessa / comunità;</li>
                <li>La data di istituzione;</li>
                <li>Chi è stato il primo bibliotecario / responsabile;</li>
                <li>Chi è /sono gli attuali responsabili;</li>
                <li>Il primo libro inventariato;</li>
                <li>L'attuale numero dei volumi presenti;</li>
                <li>Quanti sono gli iscritti;</li>
                <li>Se vi sono libri unici / rari / prime edizioni;</li>
                <li>Attività passate / presenti / future;</li>
                <li>Aneddoti sui libri o sui fruitori</li>
            </ul>

            <p>
                Le attività e la metodologia adottate sono state le seguenti: contatti con le biblioteche del
                Pordenonese, avviando le registrazioni delle interviste per la successiva trasmissione in radio.
            </p>

            <p>Il progetto realizzato si rivolge a tutte le età</p>

            <p>
                Al progetto è stata data diffusione mediante uno spot pubblicitario che è andato in onda per tutto
                il periodo del progetto.
            </p>
            <p>Parimenti la pubblicità è stata veicolata nel proprio sito web e sui social.</p>

            <p>Nello specifico sono state coinvolte le Biblioteche dei Comuni di:</p>
            <ul className='progetto-indent'>
                <li>Prata di Pordenone;</li>
                <li>Brugnera;</li>
                <li>Maniago;</li>
                <li>San Martino a Tagliamento;</li>
                <li>Cordenons</li>
            </ul>

            <h3>Programmazione Radiofonica</h3>
            <p>Tutte le interviste sono state trasmesse in radio.</p>
            <p>Le stesse verranno riproposte in replica nei prossimi mesi per dare ancora risalto al progetto.</p>

            <h3>Durata del progetto</h3>
            <p>Il progetto è stato realizzato dal 1° gennaio 2025 al 31 maggio 2025.</p>

            <h3>Estensione territoriale</h3>
            <p>
                Il progetto ha coinvolto direttamente i comuni di Prata di Pordenone, Brugnera, Maniago, San
                Martino al Tagliamento e Cordenons.
            </p>

            <h3>Convenzioni e Partner</h3>
            <p>Nell'ambito del progetto è stata attiva la convenzione con il Comune di Prata di Pordenone.</p>
            <p>Nessun partner coinvolto nel progetto.</p>

            <h3>Volontari coinvolti</h3>
            <p>
                I volontari coinvolti nel progetto nel periodo 1° gennaio 2025 – 31 maggio 2025 sono in numero
                di tre in periodi diversi.
            </p>

            <ProgettoNav prevPath='/progetto-locali-storici' nextPath='/progetto-spasso-fvg' />
        </div>
    );
}

export default Progetto4;
